// @flow
import _ from 'lodash'
import type {
  Crop,
  LeadformCustomQuestion,
  LeadformStockQuestions
} from '../../../components/types'

type Errors = Array<string>

export type LeadformErrors = {|
  nameErrors: Errors,
  vkGroupErrors: Errors,
  fbGroupErrors: Errors,
  titleErrors: Errors,
  descriptionErrors: Errors,
  imageErrors: Errors,
  questionsErrors: Errors,
  privacyPolicyUrlErrors: Errors,
  confirmationTextErrors: Errors
|}

type State = {|
  id: number | null,
  isLoading: boolean,
  isOpen: boolean,
  name: string,
  vkGroup: {| id: number, label: string |} | null,
  fbGroup: {| id: number, label: string |} | null,
  title: string,
  description: string,
  imageStoreId: string,
  vkCrop: Crop | null,
  stockQuestions: LeadformStockQuestions,
  questions: Array<LeadformCustomQuestion>,
  privacyPolicyUrl: string,
  confirmationText: string,
  ...LeadformErrors
|}

type InitialAction = {|
  +type: 'LEADFORM_EDIT.INIT',
  +state: State
|}

type PatchAction = {|
  +type: 'LEADFORM_EDIT.PATCH',
  +state: $Shape<State>
|}

type OpenAction = {|
  +type: 'LEADFORM_EDIT.OPEN',
  +id?: number | null
|}

type ResetAction = {|
  +type: 'LEADFORM_EDIT.RESET'
|}

type Action = InitialAction | PatchAction | OpenAction | ResetAction

export type { State }

const initialState: State = {
  id: null,
  isLoading: false,
  isOpen: false,
  name: '',
  nameErrors: [],
  vkGroup: null,
  vkGroupErrors: [],
  fbGroup: null,
  fbGroupErrors: [],
  title: '',
  titleErrors: [],
  description: '',
  descriptionErrors: [],
  imageStoreId: '',
  imageErrors: [],
  vkCrop: null,
  stockQuestions: {
    name: false,
    patronymic: false,
    surname: false,
    email: false,
    phone: false,
    age: false,
    birthday: false,
    location: false
  },
  questions: [],
  questionsErrors: [],
  privacyPolicyUrl: '',
  privacyPolicyUrlErrors: [],
  confirmationText: '',
  confirmationTextErrors: []
}

export function init(state: State): InitialAction {
  return {
    type: 'LEADFORM_EDIT.INIT',
    state
  }
}

export function patch(diff: $Shape<State>): PatchAction {
  return {
    type: 'LEADFORM_EDIT.PATCH',
    state: diff
  }
}

export function open(id: number | null): OpenAction {
  return {
    type: 'LEADFORM_EDIT.OPEN',
    id: _.isNumber(id) ? id : null
  }
}

export function reset(): ResetAction {
  return {
    type: 'LEADFORM_EDIT.RESET'
  }
}

export default function reducer(state: State = initialState, action: Action) {
  switch (action.type) {
    case 'LEADFORM_EDIT.INIT': {
      return action.state
    }
    case 'LEADFORM_EDIT.PATCH': {
      return { ...state, ...action.state }
    }
    case 'LEADFORM_EDIT.OPEN': {
      return { ...state, isOpen: true, id: action.id }
    }
    case 'LEADFORM_EDIT.RESET': {
      return initialState
    }
    default:
      return state
  }
}
